document.addEventListener('DOMContentLoaded',()=>{
  const audio=document.querySelector('[data-theme-audio]');
  const songButton=document.querySelector('[data-theme-song]');
  if(audio&&songButton){
    const icon=songButton.querySelector('.md-song-icon');
    const label=songButton.querySelector('[data-song-label]');
    const setPlaying=playing=>{
      songButton.classList.toggle('playing',playing);
      songButton.setAttribute('aria-pressed',String(playing));
      songButton.setAttribute('aria-label',`${playing?'Pause':'Play'} Molly and Daisy theme song`);
      if(icon)icon.textContent=playing?'Ⅱ':'▶';
      if(label)label.textContent=playing?'PAUSE SONG':'PLAY SONG';
    };
    songButton.addEventListener('click',async()=>{
      if(audio.paused){
        try{await audio.play();setPlaying(true)}catch(error){setPlaying(false)}
      }else{audio.pause();setPlaying(false)}
    });
    audio.addEventListener('ended',()=>setPlaying(false));
    audio.addEventListener('pause',()=>setPlaying(false));
  }
  document.querySelectorAll('[data-youtube-button]').forEach(link=>{
    link.addEventListener('click',event=>{
      event.preventDefault();
      const opened=window.open(link.href,'_blank','noopener,noreferrer');
      if(!opened) window.location.href=link.href;
    });
  });
  const menu=document.querySelector('.md-mobile-menu');
  const open=document.querySelector('.md-menu-button');
  const close=document.querySelector('.md-menu-close');
  if(menu&&open&&close){
    open.addEventListener('click',()=>{menu.classList.add('is-open');menu.setAttribute('aria-hidden','false');open.setAttribute('aria-expanded','true')});
    close.addEventListener('click',()=>{menu.classList.remove('is-open');menu.setAttribute('aria-hidden','true');open.setAttribute('aria-expanded','false')});
  }
  const tabs=[...document.querySelectorAll('[data-mail-tab]')];
  tabs.forEach(tab=>tab.addEventListener('click',()=>{
    tabs.forEach(t=>t.classList.toggle('is-active',t===tab));
    document.querySelectorAll('[data-mail-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.mailPanel===tab.dataset.mailTab));
  }));
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const mainImage=gallery.querySelector('[data-product-main-image]');
    const thumbnails=[...gallery.querySelectorAll('[data-product-thumbnail]')];
    thumbnails.forEach(thumbnail=>thumbnail.addEventListener('click',()=>{
      if(!mainImage)return;
      mainImage.src=thumbnail.dataset.imageSrc;
      mainImage.alt=thumbnail.dataset.imageAlt||'';
      thumbnails.forEach(item=>{
        const active=item===thumbnail;
        item.classList.toggle('is-active',active);
        if(active)item.setAttribute('aria-current','true');else item.removeAttribute('aria-current');
      });
    }));
  });
  const world=document.querySelector('.md-secret-world');
  if(!world)return;
  const file=world.querySelector('.md-file-one');
  const locker=world.querySelector('.md-locker-scene');
  const journal=world.querySelector('.md-journal');
  const image=world.querySelector('.md-locker-image');
  const input=world.querySelector('#md-code');
  const enter=world.querySelector('.md-code-box button');
  const message=world.querySelector('.md-code-message');
  const ordinary=locker.dataset.ordinary;
  const seaweed=locker.dataset.seaweed;
  file?.addEventListener('click',()=>{locker.classList.add('is-open');locker.setAttribute('aria-hidden','false');setTimeout(()=>input.focus(),250)});
  const unlock=()=>{
    const typed=input.value.replace(/[^0-9]/g,'');
    const wanted=(world.dataset.unlockCode||'1453').replace(/[^0-9]/g,'');
    if(typed!==wanted){message.textContent='TRY AGAIN';input.classList.add('shake');setTimeout(()=>input.classList.remove('shake'),350);return}
    message.textContent='UNLOCKED';enter.disabled=true;input.disabled=true;
    image.src=ordinary;
    setTimeout(()=>{
      let sea=false,count=0;
      const glitch=setInterval(()=>{sea=!sea;image.src=sea?seaweed:ordinary;locker.classList.toggle('glitch',sea);count++;if(count>=6){clearInterval(glitch);setTimeout(()=>{locker.classList.remove('is-open');locker.setAttribute('aria-hidden','true');journal.classList.add('is-open');journal.setAttribute('aria-hidden','false')},400)}},360);
    },2500);
  };
  enter?.addEventListener('click',unlock);input?.addEventListener('keydown',e=>{if(e.key==='Enter')unlock()});
});
